import { Component, OnInit } from '@angular/core';
import { vendorsDB } from '../../../shared/tables/vendor-list';

@Component({
  selector: 'app-list-vendors',
  templateUrl: './list-vendors.component.html',
  styleUrls: ['./list-vendors.component.scss']
})
export class ListVendorsComponent implements OnInit {
  public vendors = [];

  constructor() {
    this.vendors = vendorsDB.data;
  }

  public settings = {
    actions: {
      position: 'right'
    },
    columns: {
      vendor: {
        title: 'Proveedor',
        type: 'html',
      },
      products: {
        title: 'Productos'
      },
      store_name: {
        title: 'Tienda'
      },
      date: {
        title: 'Fecha'
      },
      balance: {
        title: 'Balanca Saldo',
      },
      revenue: {
        title: 'Ingresos',
      }
    },
  };

  ngOnInit() {
  }

}
